module.exports = __webpack_public_path__ + "static/media/library_banner.edc9bbd2.png";